<ng-container [ngSwitch]="displayMode">
  <div *ngSwitchCase="'full'" class="container-full">
    <div class="actions">
      <h4>Notes</h4>
      <shared-whiteboard-icon [type]="'Clinical note'"
        [ngClass]="{ 'white-icon-button-file': !(isMobile$ | async) }">
      </shared-whiteboard-icon>

      <button mat-icon-button aria-label="Take Picture" (click)="takePicture()">
        <mat-icon class="icons">camera_alt</mat-icon>
      </button>

      <button mat-icon-button aria-label="Attach File" (click)="openAddFileDialog()">
        <mat-icon class="icons">attach_file</mat-icon>
      </button>

      <div *ngIf="(useNewNora$ | async)" id="nora-recorder-toggle"></div>

      <ng-container *ngIf="!(useNewNora$ | async)">
        <ng-container *ngIf="!(noraAudioService.recording$ | async)">
          <button *ngIf="sidebar$ | async as sidebar" mat-icon-button
            [ngClass]="{ active: sidebar === SidebarLocations.NORA_CONSULT_SUMMARY }"
            [disabled]="toggleSidebar.loading$ | async" (click)="toggleSidebar.trigger()">
            <mat-icon matTooltip="Record Consult" class="img exec-icon" fontSet="material-icons-outlined">
              mic_none
            </mat-icon>
          </button>
        </ng-container>
        <button *ngIf="noraAudioService.recording$ | async" mat-icon-button
          [disabled]="stopRecording.loading$ | async" (click)="stopRecording.trigger()">
          <mat-icon matTooltip="Recording in progress" class="img exec-icon"
            style="color: red; animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
            fontSet="material-icons-outlined">
            stop_circle
          </mat-icon>
        </button>
      </ng-container>
    </div>

    <div [formGroup]="clinicalNoteForm" class="clinical-note-field">
      <mat-form-field appearance="outline" floatLabel="always"
        class="form-field-full-width full-height">
        <textarea matInput formControlName="clinicalNote" class="textarea-auto-resize full-height"
          placeholder="Capture general clinical notes"></textarea>
      </mat-form-field>
    </div>
  </div>

  <ng-template ngSwitchDefault>
    <div class="container">
      <div class="containerBody">
        <ng-template #noEncounter>
          <div class="containerSubBody">
            <div class="notes-card">
              Consultation Note
              <div fxFlex></div>
            </div>
          </div>
        </ng-template>

        <div class="containerSubBody"
          *ngIf="encounterInProgress$ | async as encounter; else noEncounter">
          <div class="notes-card">
            Consultation Note
            <div fxFlex></div>
            <button mat-icon-button (click)="takePicture()">
              <mat-icon class="icons">camera_alt</mat-icon>
            </button>

            <button mat-icon-button aria-label="Attach File" (click)="openAddFileDialog()">
              <mat-icon class="icons">attach_file</mat-icon>
            </button>
          </div>
          <form [formGroup]="clinicalNoteForm" class="note-form">
            <div class="clinical-note-field">
              <textarea matInput formControlName="clinicalNote" class="textarea-auto-resize"
                placeholder="Capture general clinical notes about the consultation here"></textarea>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>